import React from 'react'
import others from '../../../../../public/assets/img/WomansCategory/others.png'
import aroww from '../../../../../public/assets/img/WomansCategory/aroww.png'
import star from '../../../../../public/assets/img/WomansCategory/star.png'
import { guestAccountDetailSlice } from 'src/store/slices/guestAccountDetailSlice'
import { useAppDispatch } from 'src/store/store'
import AosAnimation from 'src/utils/AosAnimation'
import FindStyleNodata from 'src/components/FindStyleNodata'
import Link from 'next/link'

export default function TrendingProductCommon({ Cards }) {
  const dispatch = useAppDispatch()

  const handleRedirect = () => {
    dispatch(
      guestAccountDetailSlice({
        modal: 'authModal',
        isOpen: true,
        id: {
          media: 'https://storage.googleapis.com/bluejestic-media/bluejestic-stage/loginmedia/Live-Shopping-Short.mp4',
          modalFor: 'login',
          startWith: 'loginModal',
        },
      }),
    )
  }

  const handleProductOpen = (product) => {
    // dispatch(
    //   fetchModalData({
    //     allModalData: [
    //       ...getAllState?.allModalData,
    //       {
    //         modal: 'productDetail',
    //         isOpen: true,
    //         store_id: 0,
    //         id: product?.id,
    //         modalFor: 'bigModal',
    //         startDate: moment().toISOString(),
    //       },
    //     ],
    //     lastModalData: getAllState?.lastModalData,
    //   }),
    // )
  }

  return true ? (
    <div className="row trending_product_block_row ">
      {Cards.map((Data, i) => {
        return (
          <React.Fragment key={i}>
            {Data.parent_fill ? (
              <>
                {' '}
                {/* <AosAnimation animationType="fade-up" duration={1000} delay={100}> */}
                <div key={`q${i + 1}`} className="card_col ">
                  <Link href={`/product/${Data.child[0]?.product_data?.slug}`}>
                    <div className="cardcover">
                      <div className="card_top">
                        <img src={Data.child[0]?.product_data?.images?.[0]?.src} alt="card_top_img" />
                      </div>
                      <div className="card_bottom">
                        <div
                          className="WomeCardContent"
                          onClick={() => handleProductOpen(Data?.child[0]?.product_data)}
                        >
                          <h1>{Data?.child[0]?.product_data?.title}</h1>
                          <div className="WomenCardPrice">
                            <p>${Data?.child[0]?.product_data?.dis_price}</p>
                            <del>
                              {Data?.child[0]?.product_data?.dis_listPrice ? '$' : ''}{' '}
                              {Data?.child[0]?.product_data?.dis_listPrice}{' '}
                            </del>
                          </div>
                        </div>
                      </div>
                    </div>
                  </Link>
                  <Link href={`/product/${Data.child[1]?.product_data?.slug}`}>
                    <div className="cardcover">
                      <div className="card_top">
                        <img src={Data.child[1]?.product_data?.images?.[0]?.src} alt="card_top_img" />
                      </div>
                      <div className="card_bottom">
                        <div
                          className="WomeCardContent"
                          onClick={() => handleProductOpen(Data?.child[0]?.product_data)}
                        >
                          <h1>{Data?.child[0]?.product_data?.title}</h1>
                          <div className="WomenCardPrice">
                            <p>${Data?.child[0]?.product_data?.dis_price}</p>
                            <del>
                              {Data?.child[0]?.product_data?.dis_listPrice ? '$' : ''}{' '}
                              {Data?.child[0]?.product_data?.dis_listPrice}{' '}
                            </del>
                          </div>
                        </div>
                      </div>
                    </div>
                  </Link>
                </div>
                {/* </AosAnimation> */}
              </>
            ) : (
              <>
                {/* <AosAnimation animationType="fade-up" duration={1000} delay={100}> */}
                <div className="card_col">
                  <Link href={`/product/${Data?.product_data?.slug}`}>
                    <div className="cardcover">
                      <div className="card_top">
                        <img src={Data?.product_data?.images?.[0]?.src} alt="card_top_img" />
                      </div>
                      <div className="card_bottom">
                        <div className="WomeCardContent" onClick={() => handleProductOpen(Data?.product_data)}>
                          <h1>{Data?.product_data?.title}</h1>
                          <div className="WomenCardPrice">
                            <p>${Data?.product_data?.dis_price}</p>
                            <del>
                              {Data?.product_data?.dis_listPrice ? '$' : ''} {Data?.product_data?.dis_listPrice}{' '}
                            </del>
                          </div>
                        </div>
                      </div>
                    </div>
                  </Link>
                </div>
                {/* </AosAnimation> */}
              </>
            )}
          </React.Fragment>
        )
      })}
    </div>
  ) : (
    <FindStyleNodata />
  )
}
